import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './affiliate_types.2';

export function getAffiliateUserStatus(variable?: null, options?: GqlRequestOptions) {
  const query = 'query GetAffiliateUserStatus { reward_user_account_status }';
  return gql_request<types.GetAffiliateUserStatus, null>('GetAffiliateUserStatus', query, variable, { use_consumer: true, ...options });
}

export function createAffiliatePdpShareLink(variable: types.CreateAffiliatePdpShareLinkVariables, options?: GqlRequestOptions) {
  const query = 'fragment AffiliateShareLink on AffiliateShareLink { id short_url long_url } mutation CreateAffiliatePdpShareLink($input: CreateAffiliatePdpShareLinkInput!) { createAffiliatePdpShareLink(input: $input) { ...AffiliateShareLink } }';
  return gql_request<types.CreateAffiliatePdpShareLink, types.CreateAffiliatePdpShareLinkVariables>('CreateAffiliatePdpShareLink', query, variable, { use_consumer: true, ...options });
}

